import React from 'react'
import { HomeComponent } from './component'

export const Container: React.FC = () => {
  return <HomeComponent />
}
